// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__-i2Cu","error":"Textarea_error__Fc16X","readonly":"Textarea_readonly__2shkG","disabled":"Textarea_disabled__1foYN"};